<template>
    <div>
        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-checkbox-group
                    name="Condição avaliada"
                    v-model="data.model.condicaoAvaliada"
                >
                    <rkm-form-checkbox
                        v-for="condicao in data.form.condicaoAvaliada"
                        :disabled="disableCondicao(condicao.id)"
                        :key="condicao.id"
                        :value="condicao.id"
                        class="w-25 m-0"
                    >
                        {{ condicao.descricao }}
                    </rkm-form-checkbox>
                </rkm-form-checkbox-group>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-area
                    no-margin-top
                    title="Doenças transmissíveis"
                >
                    <rkm-row>
                        <rkm-col cols="12">
                            <rkm-form-checkbox-group
                                name="Doenças transmissíveis"
                                v-model="data.model.doencaTransmissivel"
                            >
                                <rkm-form-checkbox
                                    v-for="doenca in data.form.doencaTransmissivel"
                                    :key="doenca.id"
                                    :value="doenca.id"
                                    class="w-25 m-0"
                                >
                                    {{ doenca.descricao }}
                                </rkm-form-checkbox>
                            </rkm-form-checkbox-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-area
                    no-margin-top
                    title="Rastreamentos"
                >
                    <rkm-row>
                        <rkm-col cols="12">
                            <rkm-form-checkbox-group
                                name="Rastreamento"
                                v-model="data.model.rastreamento"
                            >
                                <rkm-form-checkbox
                                    v-for="rastreamento in data.form.rastreamento"
                                    :key="rastreamento.id"
                                    :value="rastreamento.id"
                                    class="w-25 m-0"
                                >
                                    {{ rastreamento.descricao }}
                                </rkm-form-checkbox>
                            </rkm-form-checkbox-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-area
                    no-margin-top
                    title="Outros"
                >
                    <template slot="trailing">
                        <rkm-button
                            @click="$refs.Modal.open()"
                            color="primary"
                            small
                            title="Adicionar"
                        >
                            <rkm-icon icon="plus" />
                        </rkm-button>
                    </template>

                    <rkm-row>
                        <rkm-col cols="12">
                            <List
                                :data="data"
                                @edit="$refs.Modal.open($event)"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import List from './List'
import Modal from './Modal'

// Enums.
import condicaoAvaliada from '@/enums/atencao-basica/atendimento-individual/condicaoAvaliada'

export default {
    components: {List, Modal},
    data: () => ({
        enums: {condicaoAvaliada},
    }),
    methods: {
        disableCondicao(condicaoId) {
            return [this.enums.condicaoAvaliada.SAUDE_MENTAL, this.enums.condicaoAvaliada.SAUDE_SEXUAL].includes(condicaoId)
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>
